/**
* 系统管理 管理员
*/
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>角色员工管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="username" placeholder="输入用户名"></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="mobile" placeholder="输入手机号"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="getdata(1)">搜索</el-button>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" @selection-change="selectChange" :data="userData" highlight-current-row v-loading="loading"
      border element-loading-text="拼命加载中" style="width: 100%">
      <!-- <el-table-column align="center" type="selection" width="50">
      </el-table-column> -->
      <el-table-column align="center" sortable prop="id" label="编号">
      </el-table-column>
      <el-table-column align="center" sortable prop="username" label="用户名">
      </el-table-column>
      <el-table-column align="center" sortable prop="name" label="员工名称" width="120">
      </el-table-column>
      <el-table-column align="center" sortable prop="state" label="状态" width="120">
      </el-table-column>
      <el-table-column align="center" sortable prop="createTime" label="创建时间">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.createTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column align="center" sortable prop="updateTime" label="更新时间">
        <template slot-scope="scope">
          <div>{{ transformDate(scope.row.updateTime) }}</div>
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="center"
        sortable
        prop="sex"
        label="角色"
        min-width="50"
      >
        <template slot-scope="scope">
          <div v-for="item in rolesList">
            <span v-if="scope.row.rolesId==item.id">{{item.rolesName}}</span>
          </div>
        </template>
</el-table-column> -->
      <!-- <el-table-column label="已关联项目" align="center" prop="drugName">
        <template slot-scope="scope">
          <div >
            {{getProjectArr(scope.row.projectArr)}}
          </div>
        </template>
      </el-table-column> -->
      <!-- <el-table-column label="入库检查员选择" align="center" prop="drugName">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-table-column> -->

      <el-table-column label="操作" min-width="300">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="deleteAdmin(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="60%" @click="closeDialog('edit')">
      <el-form label-width="80px" ref="editForm" :model="editForm">
        <el-form-item label="姓名" prop="name">
          <el-input size="small" v-model="editForm.name" auto-complete="off" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="username">
          <el-input size="small" v-model="editForm.username" auto-complete="off" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="mobile">
          <el-input size="small" v-model="editForm.password" placeholder="请输入密码"></el-input>
        </el-form-item>
        <el-form-item label="权限管理" prop="mobile">
          <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
            @change="handleCheckAllChange">全选</el-checkbox>
          <el-checkbox-group v-model="editForm.menuIds" @change="handleCheckedCitiesChange">
            <el-checkbox v-for="city in cities" :label="city" :key="city">{{ city }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <!-- <el-form-item label="角色" prop="rolesId">
          <el-select
            size="small"
            v-model="editForm.rolesId"
            placeholder="请选择"
            class="userRole"
          >
            <el-option
              v-for="item in rolesList"
              :key="item.value"
              :label="item.rolesName"
              :value="item.id"
              :disabled="item.disabled"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <!-- <el-form-item label="手机号" prop="mobile">
          <el-input
            size="small"
            v-model="editForm.mobile"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item> -->
        <!-- <el-form-item label="性别" prop="sex">
          <el-radio v-model="editForm.sex" label="男">男</el-radio>
          <el-radio v-model="editForm.sex" label="女">女</el-radio>
        </el-form-item> -->


      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeDialog('edit')">取消</el-button>

        <el-button size="small" type="primary" :loading="loading" class="title" @click="addAdmin()"
          v-if="title == '添加用户'">添加</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="upAdmin()"
          v-if="title == '修改用户'">修改</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// 导入请求方法
import {
  getAdminList,
  addAdmin,
  upAdmin,
  deleteAdmin
} from "../../api/userMG";
import admin from "./js/admin"
import Pagination from "../../components/Pagination";
const cityOptions = admin.params;
export default {
  data() {
    return {
      username: "", //搜索名字
      mobile: "", //搜索手机号
      rolesList: [], //角色列表
      // 编辑与添加
      editForm: {
        username: "",
        password: "",
        name: "",
        mobile: "",
        sex: "",
        rolesId: "",
        menuIds: [],
      },

      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      title: "添加用户",
      editFormVisible: false, //控制编辑页面显示与隐藏
      dataAccessshow: false, //控制数据权限显示与隐藏
      unitAccessshow: false, //控制所属单位隐藏与显示

      // 选择数据
      selectdata: [],
      // rules表单验证

      //用户数据
      userData: [],

      // 选中
      checkmenu: [],
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 20,
        total: 10,
      },
      stationList: [],
      stationArr: "",
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: false
    };
  },
  // 注册组件
  components: {
    Pagination,
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(1);
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleCheckAllChange(val) {
      this.editForm.menuIds = val ? cityOptions : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.cities.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.cities.length;
    },
    getProjectArr(projectArr) {
      if (!projectArr) {

        return "";
      }
      var str = "";
      var arr = JSON.parse(projectArr)
      this.projectList.forEach(element => {

        arr.forEach(id => {

          if (element.id == id) {
            str = str + element.projectName + ","
          }

        });

      });
      return str;
    },


    // 获取数据方法
    getdata(page) {
      this.editFormVisible = false;
      this.loading = true;
      // page = (page - 1) * 20;
      // 获取用户列表
      var parameter = {
        username: this.username,
        mobile: this.mobile,
        page: (page - 1) * 20,
      };
      getAdminList(parameter).then((res) => {
        this.loading = false;
        if (res.code != 200) {
          this.$message({
            type: "info",
            message: res.msg,
          });
        } else {
          this.userData = res.data.list;
          // 分页赋值
          this.pageparm.currentPage = page;
          this.pageparm.total = res.data.total;
        }
      });
    },


    // 分页插件事件
    callFather(parm) {
      // this.formInline.page = parm.currentPage;
      // this.formInline.limit = parm.pageSize;
      this.getdata(parm.currentPage);
    },


    //显示编辑界面
    handleEdit(index, row) {
      this.editFormVisible = true;
      if (row != undefined && row != "undefined") {
        this.title = "修改用户";
        let obj = { ...row }
        if (obj.menuIds !== undefined && obj.menuIds != "undefined" && obj.menuIds != null) {
          this.editForm = { ...obj, menuIds: JSON.parse(row.menuIds) }
          console.log('this.editForm', this.editForm)
          this.isIndeterminate = true
          this.checkAll = true
        } else {
          this.checkAll = false
          this.isIndeterminate = false
          this.editForm = { ...obj, menuIds: [] }
        }
        // this.editForm.id = row.id
        // this.editForm.username = row.username
        // this.editForm.password = row.password
        // this.editForm.name = row.name
        // this.editForm.mobile = row.mobile
        // this.editForm.sex = row.sex
        // this.editForm.state= row.state
        // this.editForm.checkedCities = JSON.parse(row.menuIds);
      } else {
        this.title = "添加用户";
        this.editForm.username = "";
        this.editForm.password = "";
        this.editForm.name = "";
        this.editForm.mobile = "";
      }
    },
    // 添加用户
    // addUser() {

    //   this.loading = true;
    //   var editForm = this.editForm;
    //   editForm.stationId = JSON.stringify(this.stationArr)

    //   addUser(editForm).then((res) => {
    //     this.loading = false;
    //     if (res.code == 200) {
    //       this.$message({
    //         type: "success",
    //         message: res.msg,
    //       });
    //       this.getdata(1);
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
    // },
    addAdmin() {
      // this.loading = true;
      // var editForm = this.editForm;
      // editForm.stationId = JSON.stringify(this.stationArr)
      // console.log
      let objData = {}
      Object.keys(this.userData[0]).forEach(key => {
        objData[key] = this.userData[0][key]; // 复制值
        // 或者设置为默认值
        // objData[key] = '';
      });
      console.log(objData, 'objData')
      console.log(this.editForm, 'this.editForm')
      let dataAdd = { ...objData, ...this.editForm, menuIds: JSON.stringify(this.editForm.menuIds) }
      console.log(dataAdd, 'this.dataAdds')
      // return
      addAdmin(dataAdd).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.getdata(1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 修改用户
    upAdmin() {
      this.loading = true;
      // var editForm = this.editForm;
      // console.log('this.editForm', this.editForm)
      // let params={
      //   id:this.editForm.id,
      //   state:this.editForm.state,
      //   name:this.editForm.name,
      //   username:this.editForm.username,
      //   password:this.editForm.password,
      //   menuIds:JSON.stringify(this.editForm.checkedCities)
      // }
      let params = { ...this.editForm, menuIds: JSON.stringify(this.editForm.menuIds) }
      console.log('this.params', params)
      console.log('this.userData', this.userData)
      // delete params.age;
      // return
      upAdmin(params).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.editForm.id = ''
          this.editForm.state = ''
          this.editForm.name = ''
          this.editForm.username = ''
          this.editForm.password = ''
          this.editForm.checkedCities = []
          this.getdata(1);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    // 选择复选框事件
    selectChange(val) {
      this.selectdata = val;
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == "edit") {
        this.editFormVisible = false;
      } else if (dialog == "perm") {
        this.dataAccessshow = false;
      } else if (dialog == "unit") {
        this.unitAccessshow = false;
      }
    },
    // 删除用户
    // deleteUser(index, row) {
    //   this.$confirm("确定要删除吗?", "信息", {
    //     confirmButtonText: "确定",
    //     cancelButtonText: "取消",
    //     type: "warning",
    //   })
    //     .then(() => {
    //       // 删除
    //       deleteUser({ id: row.id })
    //         .then((res) => {
    //           if (res.code == 200) {
    //             this.$message({
    //               type: "success",
    //               message: "数据已删除!",
    //             });
    //             this.getdata(1);
    //           } else {
    //             this.$message({
    //               type: "info",
    //               message: res.msg,
    //             });
    //           }
    //         })
    //         .catch((err) => {
    //           this.loading = false;
    //           this.$message.error("数据删除失败，请稍后再试！");
    //         });
    //     })
    //     .catch(() => {
    //       this.$message({
    //         type: "info",
    //         message: "已取消删除！",
    //       });
    //     });
    // },
    deleteAdmin(index, row) {
      this.$confirm("确定要删除吗?", "信息", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 删除
          deleteAdmin({ id: row.id })
            .then((res) => {
              if (res.code == 200) {
                this.$message({
                  type: "success",
                  message: "数据已删除!",
                });
                this.getdata(1);
              } else {
                this.$message({
                  type: "info",
                  message: res.msg,
                });
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("数据删除失败，请稍后再试！");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除！",
          });
        });
    },

    // 刷新缓存
    refreshCache(index, row) {
      userFlashCache(row.userName)
        .then((res) => {
          if (res.success) {
            this.$message({
              type: "success",
              message: "刷新成功！",
            });
            this.getdata(this.formInline);
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error("刷新失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}

.userRole {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/views/system/Admin.vue